module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Medium-WebS.5d24cb4e.svg";